/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SmsCampaignRecordDeliveryStatus {
    PENDING = 'Pending',
    DELIVERED = 'Delivered',
    BLACK_LIST = 'BlackList',
    CHECK_OK = 'CheckOk',
    NOT_SENT = 'NotSent',
    ERROR = 'Error',
    RATE_LIMITED = 'RateLimited',
}
